import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

interface NetworkState {
  isOnline: boolean
}

const initialState: NetworkState = {
  isOnline: true,
}

export const networkSlice = createSlice({
  name: 'network',
  initialState,
  reducers: {
    setOnline: (state, action: PayloadAction<boolean>) => {
      state.isOnline = action.payload
    },
  },
})

export const { setOnline } = networkSlice.actions

export const selectIsOnline = (state: RootState) => state.network.isOnline

export default networkSlice.reducer
